import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { socket, socketGet } from "services/socket-client";
import { bumpLeaveCalendarRefresh } from "./leaveCalendarSlice";

export function useLeaveCalendarSocket(companyId: string | undefined) {
  const dispatch = useDispatch();
  const lastCompanyRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!companyId) return;
    lastCompanyRef.current = companyId;
    let cancelled = false;

    const subscribe = async () => {
      try {
        await socketGet(`/${companyId}/sockets/subscribe`);
        if (cancelled) return;
      } catch (err) {
        if (cancelled) return;
        console.warn("[leave-socket] subscribe failed", { companyId });
      }
    };

    const handleLeaveChange = (...args: unknown[]) => {
      const payload = args[0] as { companyId: string } | undefined;
      if (String(payload?.companyId) !== String(companyId)) return;
      dispatch(bumpLeaveCalendarRefresh());
    };

    const onReconnect = () => {
      subscribe();
      dispatch(bumpLeaveCalendarRefresh());
    };

    socket.on("leave-created", handleLeaveChange);
    socket.on("leave-updated", handleLeaveChange);
    socket.on("leave-deleted", handleLeaveChange);
    socket.on("reconnect", onReconnect);

    subscribe();

    return () => {
      cancelled = true;
      socket.off("leave-created", handleLeaveChange);
      socket.off("leave-updated", handleLeaveChange);
      socket.off("leave-deleted", handleLeaveChange);
      socket.off("reconnect", onReconnect);
    };
  }, [companyId, dispatch]);
}
